import { Component } from '@angular/core';
import { ProjectsService } from '../services/project.service';
import { AccountService } from '../services/account.service';

import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ActivatedRoute, Router } from '@angular/router';
import { ReferralService } from '../services/referral.service';

@Component({
    selector: 'app-after-login',
    templateUrl: './after-login.component.html',
    styleUrls: ['./after-login.component.scss'],
    standalone: false
})
export class AfterLoginComponent {

  constructor(
    private accountService: AccountService,
    private projectService: ProjectsService,
    public auth: AngularFireAuth,
    private router: Router,
    private route: ActivatedRoute,
    private referralService: ReferralService,
  ) {}

  ngOnInit() {
    this.auth.authState.subscribe(user => {
    if (user) {
      // Il claim è idempotente lato backend e non deve bloccare il redirect:
      // se fallisce, l'utente entra lo stesso e il cookie resta per il
      // prossimo accesso.
      this.referralService.claimPending().subscribe({ error: () => {} });
      console.log('AUTHSTATE USER', user)
      // Honor ?next=/... so flows that redirected here through AuthGuard
      // (e.g. invite email link with ?invite_token=...) land back on the
      // original URL with its query params intact.
      const next = this.route.snapshot.queryParamMap.get('next');
      if (next && next.startsWith('/')) {
        this.router.navigateByUrl(next);
        return;
      }
      this.accountService.getUserDetail().subscribe({
        next: (res) => {
          const companies: number[] = res['companies'] || [];
          if (companies.length > 0) {
            this.router.navigate([companies[0], 'projects']);
          } else {
            this.router.navigate(['onboarding']);
          }
        },
        error: () => {
          this.router.navigate(['onboarding']);
        }
      });
    } else {
      console.log('AUTHSTATE USER EMPTY', user)
      // this.currentUser = null;
      this.router.navigate(['auth','login']);
    }
    });
  }
}
